import { AppTextInput } from "../../ui/input";
import { useForgotPasswordContext } from "./ForgotPasswordProvider";
import { ChangeEvent } from "react";

export const ForgotPasswordInput = () => {
  const { state, dispatch } = useForgotPasswordContext();

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ email: event.target.value });
  };

  return (
    <AppTextInput
      onChange={handleInputChange}
      value={state.email}
      className={"w-full"}
      placeholder={"Email"}
      type={"email"}
      label={"Email"}
      error={!!state.emailError}
      helperText={state.emailError}
    />
  );
};
